class Debouncer<T> {
  timeout: ReturnType<typeof setTimeout> | null;

  delay: number;

  value: T | undefined;

  /**
   *
   */
  constructor(initialValue: T, delay = 500) {
    this.value = initialValue;
    this.delay = delay;
    this.timeout = null;
  }

  /**
   *
   */
  getValue(): T | undefined {
    return this.value;
  }

  /**
   *
   */
  setValue(newValue: T, callback?: (val: T) => void): void {
    if (this.timeout) clearTimeout(this.timeout);

    this.timeout = setTimeout(() => {
      this.value = newValue;
      callback?.(newValue);
    }, this.delay);
  }
}

export default Debouncer;
